import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { roundTimeStore } from '../../store/roundTimeStore';
import { gameStore } from '../../store/gameStore';

const CountDown = observer(({ isShuffle }) => {
  const t = useTranslation();
  const { time } = roundTimeStore;
  const { isShowDecision, isBetsClosed } = gameStore;
  return (
    <div className='tb-countdown-block'>
      {isShowDecision && (
        <>
          <p className='tb-countdown-text'>{t('PLEASE_MAKE_YOUR_DECISION')}</p>
          <div className='tb-countdown-circle'>{time}</div>
        </>
      )}
      {!isBetsClosed && !isShuffle && <p className='tb-countdown-text'> {t('PLACE_YOUR_BETS')} </p>}
    </div>
  );
});

export default CountDown;
